export default __webpack_public_path__ + "static/media/hand-smartphone.8fb8019f.jpg";